import React from "react";
import { Link } from "react-router-dom";


export  default  function ItemFund ({item,names,prices}) {





    return(
        <div className={'cc-3536'}>

            <Link to={item['nameCoin'] != 'IR' ?`/${item['nameCoin']}` : '/'}>
                <img className={'imgcoinlist pr-1'}
                     src={`https://static.sinatether.com/CoinsImg/${item['nameCoin']}.png`}/>
                <span
                    className={'text-large pr-1'}>{names[item['nameCoin']]} </span>
                <span className={'css-sym3536'}>
                    {item['nameCoin']}
                </span>
            </Link>

            <div className={'row'}>
                <div className={'col-4'}>
                    <div className={'tit3536'}>
                                        موجودی
                                    </div>
                    <div className={'bb-3536'}>
                        {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(item['balance'])}
                    </div>

                </div>

                <div className={'col-4'}>
                    <div className={'tit3536'}>
                                        بلوکه شده
                                    </div>
                    <div className={'bb-3536'}>
                    {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(item['blocked'])}

                    </div>

                </div>

                <div className={'col-4'}>
                    <div className={'tit3536'}>
                                        ارزش فعلی
                                    </div>
                    <div className={'bb-3536'}>
                    { new Intl.NumberFormat("fa",{maximumFractionDigits:0}).format(prices[item['nameCoin']])}
                        تومان
                    </div>

                </div>


            </div>


        </div>
    )

}